module.exports = __webpack_public_path__ + "static/media/bunge.b8c0dbbc.jpg";